import React from "react"
import CSSModules from "react-css-modules"
import { FormattedMessage } from 'react-intl'
import styles from "./Header.scss"
import ThemeTooltip from '../ui/Tooltip/ThemeTooltip'

const sun = (fill) => (
  <svg id="Capa_1" viewBox="0 0 512 512" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
    <g>
      <g>
        <path fill={fill} d="m256 360.099c-57.4 0-104.099-46.698-104.099-104.099s46.699-104.099 104.099-104.099 104.099 46.699 104.099 104.099-46.699 104.099-104.099 104.099zm0-178.198c-40.858 0-74.099 33.241-74.099 74.099s33.24 74.099 74.099 74.099 74.099-33.241 74.099-74.099-33.241-74.099-74.099-74.099z" />
      </g>
      <g>
        <path fill={fill} d="m256 116.071c-8.284 0-15-6.716-15-15v-86.071c0-8.284 6.716-15 15-15s15 6.716 15 15v86.071c0 8.284-6.716 15-15 15z" />
      </g>
      <g>
        <path fill={fill} d="m146.449 161.449c-3.839 0-7.678-1.464-10.606-4.393l-60.863-60.862c-5.858-5.858-5.858-15.355 0-21.213 5.857-5.858 15.355-5.858 21.213 0l60.862 60.861c5.858 5.858 5.858 15.355 0 21.213-2.928 2.929-6.767 4.394-10.606 4.394z" />
      </g>
      <g>
        <path fill={fill} d="m101.071 271h-86.071c-8.284 0-15-6.716-15-15s6.716-15 15-15h86.071c8.284 0 15 6.716 15 15s-6.716 15-15 15z" />
      </g>
      <g>
        <path fill={fill} d="m85.587 441.413c-3.839 0-7.678-1.464-10.606-4.394-5.858-5.858-5.858-15.355 0-21.213l60.862-60.861c5.858-5.857 15.356-5.857 21.213 0 5.858 5.858 5.858 15.355 0 21.213l-60.863 60.862c-2.928 2.928-6.767 4.393-10.606 4.393z" />
      </g>
      <g>
        <path fill={fill} d="m256 512c-8.284 0-15-6.716-15-15v-86.071c0-8.284 6.716-15 15-15s15 6.716 15 15v86.071c0 8.284-6.716 15-15 15z" />
      </g>
      <g>
        <path fill={fill} d="m426.413 441.413c-3.839 0-7.678-1.464-10.606-4.393l-60.862-60.861c-5.858-5.858-5.858-15.355 0-21.213 5.857-5.858 15.355-5.858 21.213 0l60.862 60.861c5.858 5.858 5.858 15.355 0 21.213-2.929 2.928-6.768 4.393-10.607 4.393z" />
      </g>
      <g>
        <path fill={fill} d="m497 271h-86.071c-8.284 0-15-6.716-15-15s6.716-15 15-15h86.071c8.284 0 15 6.716 15 15s-6.716 15-15 15z" />
      </g>
      <g>
        <path fill={fill} d="m365.551 161.449c-3.839 0-7.678-1.464-10.606-4.394-5.858-5.858-5.858-15.355 0-21.213l60.862-60.861c5.857-5.856 15.355-5.858 21.213 0s5.858 15.355 0 21.213l-60.862 60.861c-2.929 2.929-6.769 4.394-10.607 4.394z" />
      </g>
    </g>
  </svg>
)

const moon = (fill) => (
  <svg version="1.1" id="Capa_1" width="20" height="20" x="0px" y="0px" viewBox="0 0 512.001 512.001">
    <path fill={fill}  d="M367.924,8.521c70.94,127.548,25.05,288.445-102.49,359.385c-79.869,44.425-177.026,44.425-256.895,0
      C79.572,495.352,240.478,541.08,367.924,470.047s173.174-231.939,102.141-359.385C446.174,67.788,410.798,32.42,367.924,8.521z"
    />
    <path fill={fill} d="M239.353,511.984c-98.886-0.077-190.011-53.592-238.252-139.92
      c-2.309-4.098-0.869-9.296,3.229-11.605c2.599-1.466,5.777-1.466,8.384,0c123.442,68.622,279.141,24.181,347.763-99.27
      c42.951-77.262,42.951-171.232,0-248.494c-2.292-4.107-0.826-9.296,3.28-11.596c2.59-1.448,5.734-1.44,8.324,0.009
      c131.536,73.368,178.696,239.471,105.328,371.007C429.27,458.434,338.188,511.941,239.353,511.984z M31.842,388.661
      c82.587,114.495,242.342,140.363,356.837,57.776S529.042,204.095,446.455,89.6c-16.035-22.229-35.547-41.741-57.776-57.776
      c58.066,139.008-7.557,298.772-146.566,356.837C174.846,416.761,99.118,416.761,31.842,388.661z"
    />
  </svg>
)

const ThemeSwitcher = ({ onClick }) => {
  const isDark = document.body.dataset.scheme === 'dark'

  return (
    <div
      styleName={`themeSwitcher`}
      onClick={onClick}
      data-for="themeAlt"
      data-tip
    >
      {isDark ? sun("white") : moon("#747474")}

      <ThemeTooltip id="themeAlt" effect="solid" place="bottom">
        <FormattedMessage
          id="themeAlt"
          defaultMessage="{theme} theme"
          values={{ theme: isDark ? 'Light' : 'Dark' }}
        />
      </ThemeTooltip>
    </div>
  )
}

export default CSSModules(ThemeSwitcher, styles, { allowMultiple: true })